<template>
  <div :class="`c-message c-message--${type}`">
    <h3 v-if="title">{{title}}</h3>
    <p v-if="text">{{text}}</p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'message',

  props: ['type', 'title', 'text'],

  data() {
    return {};
  },
};
</script>

<style lang="scss">
.c-message {
  padding: 0.25em 1em;
  border-radius: 4px;
  color: $colour-nhs-white;

  margin-top: 0.5em;
  margin-bottom: 3em;

  border: 2px solid transparent;

  &--success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
  }

  &--error,
  &--danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
  }

  &--warning {
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeeba;
  }
  //Used on the documents view
  &--warning-solid {
    background-color: #F28521;
    color:#ffffff;
    border:0;
    height:100%;
    margin:0 0 20px 0;

    svg {
      flex-basis:25px;
    }
    p {
      width:100%;
      padding-left:15px;
    }
    @media (min-width: 768px) {
    svg {
      flex-basis:auto;
    }
      padding:15px 25px;
      p {
        width:auto;
        margin:0 0 0 10px;

      }
    }
  }
  &--center {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

}
</style>
